export const subjectNameStyles = {
  fontSize: '20px',
  color: '#333',
  marginRight: '4px',
  marginLeft: '4px',
};
export const dateStyle = {
  color: '#999',
  fontSize: '16px',
};
export const editCTC = {
  cursor: 'pointer',
  marginLeft: '12px',
};
export const bullets = {
  color: '#C4C4C4',
  padding: '0px 10px',
};
export const disableEditCta = {
  cursor: 'default',
  marginLeft: '12px',
  opacity: 0.5,
};

export const editBlock = {
  display: "block",
  width: "100%",
};
